export default __webpack_public_path__ + "static/media/useguide1.c27f485a.png";